import { Configuration } from '@azure/msal-browser';
const env = document.location.host.includes('local')
    ? 'dev'
    : document.location.host.includes('test')
    ? 'test'
    : document.location.host.includes('stage')
    ? 'stage'
    : 'production';
let msalConfig: Configuration;
if (document.location.href.includes('miracle-earpro')) {
    msalConfig = {
        auth: {
            clientId:
                env === 'test'
                    ? '2354d8a4-0796-4948-854a-b2c13f3375c8'
                    : env === 'stage'
                    ? '429de552-5317-493f-851e-e55e2368f415'
                    : env === 'production'
                    ? '950ecbef-18a7-4016-a23f-1ea80a475c28'
                    : 'c7fc6797-b1ed-48a5-adae-9c9caa00ec98',
            authority:
                env === 'test'
                    ? 'https://teststarkeyb2c.b2clogin.com/teststarkeyb2c.onmicrosoft.com/B2C_1A_MIRACLE-EARV1SIGNIN/'
                    : env === 'stage'
                    ? 'https://stagestarkeyb2c.b2clogin.com/stagestarkeyb2c.onmicrosoft.com/B2C_1A_MIRACLE-EARV1SIGNIN/'
                    : env === 'production'
                    ? 'https://starkeyb2c.b2clogin.com/starkeyb2c.onmicrosoft.com/B2C_1A_MIRACLE-EARV1SIGNIN/'
                    : 'https://devstarkeyb2c.b2clogin.com/devstarkeyb2c.onmicrosoft.com/B2C_1A_MIRACLE-EARV1SIGNIN/',
            knownAuthorities:
                env === 'test'
                    ? ['teststarkeyb2c.b2clogin.com']
                    : env === 'stage'
                    ? ['stagestarkeyb2c.b2clogin.com']
                    : env === 'production'
                    ? ['starkeyb2c.b2clogin.com']
                    : ['devstarkeyb2c.b2clogin.com'],
            redirectUri: document.location.origin,
            navigateToLoginRequestUrl: true,
            postLogoutRedirectUri: document.location.origin + '/login?/estore',
        },
        cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
    };
} else {
    msalConfig = {
        auth: {
            clientId:
                env === 'test'
                    ? '2354d8a4-0796-4948-854a-b2c13f3375c8'
                    : env === 'stage'
                    ? '429de552-5317-493f-851e-e55e2368f415'
                    : env === 'production'
                    ? '950ecbef-18a7-4016-a23f-1ea80a475c28'
                    : 'c7fc6797-b1ed-48a5-adae-9c9caa00ec98',
            authority:
                env === 'test'
                    ? 'https://teststarkeyb2c.b2clogin.com/teststarkeyb2c.onmicrosoft.com/B2C_1A_ESTOREV1SIGNIN/'
                    : env === 'stage'
                    ? 'https://stagestarkeyb2c.b2clogin.com/stagestarkeyb2c.onmicrosoft.com/B2C_1A_ESTOREV1SIGNIN/'
                    : env === 'production'
                    ? 'https://starkeyb2c.b2clogin.com/starkeyb2c.onmicrosoft.com/B2C_1A_ESTOREV1SIGNIN/'
                    : 'https://devstarkeyb2c.b2clogin.com/devstarkeyb2c.onmicrosoft.com/B2C_1A_ESTOREV1SIGNIN/',
            knownAuthorities:
                env === 'test'
                    ? ['teststarkeyb2c.b2clogin.com']
                    : env === 'stage'
                    ? ['stagestarkeyb2c.b2clogin.com']
                    : env === 'production'
                    ? ['starkeyb2c.b2clogin.com']
                    : ['devstarkeyb2c.b2clogin.com'],
            redirectUri: document.location.origin,
            navigateToLoginRequestUrl: true,
            postLogoutRedirectUri: document.location.origin + '/login?/estore',
        },
        cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
    };
}
export { msalConfig };
